const providerByValue = {
  1: 'manual',
  2: 'instagram',
  3: 'tiktok',
};

export const normalizeProvider = provider => {
  if (providerByValue[provider]) return providerByValue[provider];
  if (!provider) return '';
  return String(provider).toLowerCase();
};

export const getAccountProvider = account => {
  if (!account) return '';
  if (account.isTikTok) return 'tiktok';
  if (account.isInstagram) return 'instagram';
  if (account.isManual) return 'manual';

  const configuredProvider = normalizeProvider(account.provider);
  if (configuredProvider) return configuredProvider;

  // Older API responses only exposed isManual. A false value represented
  // an Instagram-connected account.
  return account.isManual === false ? 'instagram' : '';
};

export const isInstagramAccount = account => {
  const provider = getAccountProvider(account);
  return provider === 'instagram';
};

export const getPostProvider = (post, fallbackProvider) =>
  normalizeProvider(post && post.provider) ||
  normalizeProvider(fallbackProvider);
